export default [
  // 获取所有的菜单以及button列表用户的菜单列表
  {
    name: "ListAllMenuAction",
    url: "/action/list",
    method: "GET",
    mock: false,
  },

];
